import { Phone, Navigation } from "lucide-react";
import { WhatsAppIcon } from "./Icons";
import { TEL, WA, MAPS_DIR } from "../../lib/site";

const cls = "flex flex-1 flex-col items-center justify-center gap-1 py-2 text-[11px] font-medium text-white/90 transition-colors active:text-gold-light";

export const MobileBar = () => (
  <div data-testid="mobile-bottom-bar" className="fixed inset-x-0 bottom-0 z-50 border-t border-gold/30 bg-emerald-950/95 backdrop-blur-md md:hidden" style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
    <div className="flex divide-x divide-white/10">
      <a href={TEL} className={cls} data-testid="mobile-bar-call">
        <Phone className="h-[18px] w-[18px] text-gold" strokeWidth={1.8} /> Ara
      </a>
      <a href={WA} target="_blank" rel="noopener noreferrer" className={cls} data-testid="mobile-bar-whatsapp">
        <WhatsAppIcon className="h-[18px] w-[18px] text-gold" /> WhatsApp
      </a>
      <a href={MAPS_DIR} target="_blank" rel="noopener noreferrer" className={cls} data-testid="mobile-bar-directions">
        <Navigation className="h-[18px] w-[18px] text-gold" strokeWidth={1.8} /> Yol Tarifi
      </a>
    </div>
  </div>
);
